import "./Livesummary.css";
import redArrow from "./red.png";
import greenArrow from "./green.png";
import { NavLink } from "react-router-dom";

const Livesummary = ({
    events = [],
    homeTeam,
    awayTeam,
    dark,
    status,
    goals,
    score
}) => {

    const createPlayerUrl = (player) => {
        return `/players/${player?.name
            ?.trim()
            .replace(/[^a-zA-Z.\s]/g, "")
            .replace(/\s+/g, "-")
            .toLowerCase()
        }-${player?.id}`;
    };

    const createTeamUrl = (team) => {
        return `/teams/${team?.name
            ?.trim()
            .replace(/[^a-zA-Z0-9\s]/g, "")
            .replace(/\s+/g, "-")
            .toLowerCase()
        }-${team?.id}`;
    };

    const renderIcon = (event) => {

        switch (event.type) {

            case "Goal":
                return <span className="ball">⚽</span>;

            case "Card":

                if (
                    event.detail === "Second Yellow card" ||
                    event.detail === "Yellow Red Card"
                ) {
                    return (
                        <span className="cardStack">
                            <span className="yellowcard"></span>
                            <span className="redcard overlap"></span>
                        </span>
                    );
                }

                return (
                    <span
                        className={
                            event.detail === "Red Card"
                                ? "redcard"
                                : "yellowcard"
                        }
                    ></span>
                );

            case "subst":
            case "Substitution":
                return (
                    <span className="subicon">
                        <span className="up">
                            <img src={greenArrow} alt="" />
                        </span>
                        <span className="down">
                            <img src={redArrow} alt="" />
                        </span>
                    </span>
                );

            default:
                return null;
        }
    };

    return (
        <div
            className="livesummaryWrapper"
            style={dark ? { backgroundColor: "#333333ff" } : { backgroundColor: "white" }}
        >

            {events.map((event, index) => {

                const isHome = event.team?.id === homeTeam?.id;
                const playerUrl = createPlayerUrl(event.player);
                const assistUrl = createPlayerUrl(event.assist);
                const teamUrl = createTeamUrl(event.team);

                return (
                        
                <div  key={index}
                    className="summaryRow" 
                    style={
                        dark
                        ? { borderBottom: "1px solid #2a2d35" }
                        : { borderBottom: "1px solid #eee" }
                    }
                    >

                        <div className="summaryLeft">
                            {isHome && (
                                <>
                                    <div className="playerBlock">

                                        <NavLink
                                            to={playerUrl}
                                            style={{ textDecoration: "none", color: "inherit" }}
                                        >
                                            <p
                                                className="playerNames" style={dark ? {color: "#fafafaff"} : {color: "#161819"}}
                                            >
                                                {event.player?.name}
                                            </p>
                                        </NavLink>

                                        {event.assist?.name && (
                                            <NavLink
                                                to={assistUrl}
                                                style={{ textDecoration: "none", color: "inherit" }}
                                            >
                                                <p
                                                    className="assistName"
                                                    style={dark ? { color: "#fafafaff" } : { color: "#3e3f3f" }}
                                                >
                                                    {event.assist.name}
                                                </p>
                                            </NavLink>
                                        )}
                                    </div>

                                    <NavLink to={teamUrl}>
                                        {renderIcon(event)}
                                    </NavLink>
                                </>
                            )}
                        </div>


                        <div className="summaryCenter">

                            <p
                                className="time"
                                style={dark ? { color: "#bbbbbbff" } : { color: "#3e3f3f" }}
                            >
                                {event.time?.elapsed}
                                {event.time?.extra ? `+${event.time.extra}` : ""}
                                '
                            </p>

                            {event.type === "Goal" && (
                                <p
                                    className="score"
                                    style={dark ? { color: "#bbbbbbff" } : { color: "#3e3f3f" }}
                                >
                                    {event.score?.home} - {event.score?.away}
                                </p>
                            )}

                            {event.detail === "Half Time" && (
                                <>
                                    <p
                                        className="halftime"
                                        style={dark ? { color: "#bbbbbbff" } : { color: "#3e3f3f" }}
                                    >
                                        Half Time
                                    </p>
                                    <p
                                        className="score"
                                        style={dark ? { color: "#bbbbbbff" } : { color: "#3e3f3f" }}
                                    >
                                        {score?.halftime?.home} - {score?.halftime?.away}
                                    </p>
                                </>
                            )}

                            {event.detail === "Extra Time" && (
                                <p className="extratime">Extra Time</p>
                            )}

                            {event.detail === "Penalty Shootout" && (
                                <p className="penalty">Penalty</p>
                            )}

                            {event.detail === "Kick Off" && (
                                <p className="kickoff">Kick Off</p>
                            )}

                        </div>


                        <div className="summaryRight">
                            {!isHome && (
                                <>
                                    <NavLink to={teamUrl}>
                                        {renderIcon(event)}
                                    </NavLink>

                                    <div className="playerBlock">

                                        <NavLink
                                            to={playerUrl}
                                            style={{ textDecoration: "none", color: "inherit" }}
                                        >
                                            <p
                                                className="playerNames" style={dark ? {color: "#fafafaff"} : {color: "#161819"}}
                                            >
                                                {event.player?.name}
                                            </p>
                                        </NavLink>

                                        {event.assist?.name && (
                                            <NavLink
                                                to={assistUrl}
                                                style={{ textDecoration: "none", color: "inherit" }}
                                            >
                                                <p
                                                    className="assistName"
                                                    style={dark ? { color: "#fafafaff" } : { color: "#3e3f3f" }}
                                                >
                                                    {event.assist.name}
                                                </p>
                                            </NavLink>
                                        )}

                                    </div>
                                </>
                            )}
                        </div>

                    </div>
                );
            })}

            {status?.short === "HT" && (
                <div 
                    className="summaryRow" 
                    style={
                        dark
                        ? { borderBottom: "1px solid #2a2d35" }
                        : { borderBottom: "1px solid #eee" }
                    }
                    >

                    <div className="summaryLeft"></div>

                    <div className="summaryCenter">
                        <p className="time" style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>
                            HT
                        </p>
                        <p className="score" style={dark ? {color: "#bbbbbbff"} : {color: "#3e3f3f"}}>
                            {score?.halftime?.home} - {score?.halftime?.away}
                        </p>
                    </div>

                    <div className="summaryRight"></div>

                </div>
            )}

            {status?.short === "ET" && (
                <div 
                    className="summaryRow" 
                    style={
                        dark
                        ? { borderBottom: "1px solid #2a2d35" }
                        : { borderBottom: "1px solid #eee" }
                    }
                    >

                    <div className="summaryLeft"></div>

                    <div className="summaryCenter">
                        <p className="time" style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>
                            ET
                        </p>
                        <p className="score" style={dark ? {color: "#bbbbbbff"} : {color: "#3e3f3f"}}>
                            {goals?.home} - {goals?.away}
                        </p>
                    </div>

                    <div className="summaryRight"></div>

                </div>
            )}

            {status?.short === "PEN" && (
                <div 
                    className="summaryRow" 
                    style={
                        dark
                        ? { borderBottom: "1px solid #2a2d35" }
                        : { borderBottom: "1px solid #eee" }
                    }
                    >

                    <div className="summaryLeft"></div>

                    <div className="summaryCenter">
                        <p className="time" style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>
                            PEN
                        </p>
                        <p className="score" style={dark ? {color: "#bbbbbbff"} : {color: "#3e3f3f"}}>
                            {score?.penalty?.home} - {score?.penalty?.away}
                        </p>
                    </div>

                    <div className="summaryRight"></div>

                </div>
            )}

            {status?.short === "FT" && (
                <div 
                    className="summaryRow" 
                    style={
                        dark
                        ? { borderBottom: "1px solid #2a2d35" }
                        : { borderBottom: "1px solid #eee" }
                    }
                    >

                    <div className="summaryLeft"></div>

                    <div className="summaryCenter">
                        <p className="time" style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>
                            FT
                        </p>
                        <p className="score" style={dark ? {color: "#bbbbbbff"} : {color: "#3e3f3f"}}>
                            {goals?.home} - {goals?.away}
                        </p>
                    </div>

                    <div className="summaryRight"></div>

                </div>
            )}

        </div>
    );
};

export default Livesummary;